/**
 * ElasticScreen is a container for form steps
 */
class ElasticScreen extends ElasticInterface {
    constructor (screen) {
        super();
        this.assignObjKeys(screen);
        this.questions = this.questions.map((question) => { return new ElasticQuestion(question); });
    }

    /**
     * Perform HTML DOM rendering for every question
     * return {string} valid HTML
     */
    render () {
        return this.questions.map((question) => { return question.render(); }).join('');
    }

    /**
     * Perform all actions after rendering screen, for instance event handlers
     * returns nothing john snow
     */
    init () {
        this.questions.map((question) => { return question.init(); });
    }

    /**
     * Perform validation of all questions in current step
     * @returns {boolean}
     */
    validate () {
        let is_valid = true;

        this.questions.forEach((question) => {
            question.validate();
            /* Validate every question if any is invalid return false */
            if (question.state === ElasticQuestion.STATE_INVALID) {
                is_valid = false;
            }
        });
        return is_valid;
    }

    /**
     * Serializes all questions in current step
     * @returns {Array}
     */
    serialize () {
        let screens = [];

        this.questions.forEach((question) => {
            screens.push(question.serialize());
        });

        return screens;
    }

    /**
     * Destructs Screen data, and delegate destructuring to all questions
     * in current step
     */
    destructor () {
        this.questions.map((question) => {
            question.destructor();
            return undefined;
        });
        this.questions = undefined;
    }
}
